import { render, staticRenderFns } from "./ToolbarApps.vue?vue&type=template&id=2274a50e&scoped=true"
import script from "./ToolbarApps.vue?vue&type=script&lang=js"
export * from "./ToolbarApps.vue?vue&type=script&lang=js"
import style0 from "./ToolbarApps.vue?vue&type=style&index=0&id=2274a50e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2274a50e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2274a50e')) {
      api.createRecord('2274a50e', component.options)
    } else {
      api.reload('2274a50e', component.options)
    }
    module.hot.accept("./ToolbarApps.vue?vue&type=template&id=2274a50e&scoped=true", function () {
      api.rerender('2274a50e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toolbar/ToolbarApps.vue"
export default component.exports